import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
    Autocomplete,
    Box,
    Grid,
    Grow,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    TableSortLabel,
    TextField,
    IconButton,
    Collapse,
    Typography
} from "@mui/material";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import {
    getEquipmentReportList,
    addEquipmentReport,
    updateEquipmentReport,
    deleteEquipmentReport,
    getPlants
} from "../../store/actions/EquipmentReportActions";

import { commonSort } from "../../common";
import AddButton from "../../components/AddButton/AddButton";
import SearchBar from "../../components/SearchBar/SearchBar";
import TableButtons from "../../components/Button/TableButtons";
import LoadingBackdrop from "../../components/LoadingBackdrop/LoadingBackdrop";
import Modal from "../../components/Modal/Modal";
import { StyledTableDiv } from "../../components/StyledComponents/StyledComponents";

export default function EquipmentReport() {
    const { t } = useTranslation("translation");
    const dispatch = useDispatch();
    const { equipmentReport } = useSelector(
        (equipmentReport) => equipmentReport
    );

    const [pageLoaded, setPageLoaded] = useState(false);
    const [editable, setEditable] = useState(false);
    const [editableRow, setEditableRow] = useState("");

    const [isAddDisable, setIsAddDisable] = useState(true);

    //tabloyla alakali stateler
    const [plantList, setPlantList] = useState([]);

    //Sayfanin ilk acilmasiyla alakali stateler
    const [initialRows, setInitialRows] = useState([]);
    let [rows, setRows] = useState([]);
 
    useEffect(() => {
        loadHandler();
        getPlantCodeHandler();

    }, []);


    useEffect(() => {
        if (equipmentReport?.equipmentReportList?.resultObject?.length) {
            setRows(equipmentReport.equipmentReportList.resultObject);
            setInitialRows(equipmentReport.equipmentReportList.resultObject);           
            equipmentReport.equipmentReportList = {};
            setPageLoaded(true);
        }

        if (equipmentReport?.plantsList?.resultObject) {
            setPlantList(equipmentReport.plantsList.resultObject);
        }
        if (equipmentReport.isTaskUpdatedEquipmentReport) {
            setEditableRow(false);
            setDisableButton(false);
            loadHandler();
        }
    }, [equipmentReport]);

    const loadHandler = () => {
        dispatch(getEquipmentReportList());
    };

    const getPlantCodeHandler = () => {
        dispatch(getPlants());
    };




    const renderTableCell = (rowItems, isSortingAction = true) => {
        var directionType = sortOrder === 1 ? "asc" : "desc";
        return rowItems.map((item, index) => {
            if (item.id === "Actions") {
                return <TableCell align="center">{t("Actions")}</TableCell>;
            } else {
                return isSortingAction ? (
                    <TableCell align="center" id={`erg_TableHead_${index}`}>
                        <TableSortLabel
                            active={sortColumn === item.id}
                            direction={directionType}
                            onClick={() =>
                                handleSort(cloneObject(initialRows), item.id)
                            }
                            style={{ paddingLeft: 25 }}
                        >
                            {item.label}
                        </TableSortLabel>
                    </TableCell>
                ) : (
                    <TableCell align="center">{item.label}</TableCell>
                );
            }
        });
    };

     //dynamic sort function
     let [sortOrder, setSortOrder] = useState();
     let [sortColumn, setSortColumn] = useState();

     const handleSort = (row, column) => {
         const sortedList = commonSort(row, column);
         setSortOrder(sortedList[0]);
         setSortColumn(sortedList[1]);
         setInitialRows(sortedList[2]);
         setRows(sortedList[2]);
     };

     const cloneObject = (obj) => {
        return JSON.parse(JSON.stringify(obj));
    };

     // Pagination
     const [currentPage, setCurrentPage] = useState(0);
     const [rowsPerPage, setRowsPerPage] = useState(20);
     const handleChangePage = (_event, newPage) => {
         setCurrentPage(newPage);
     };
 
     const handleChangeRowsPerPage = (event) => {
         setRowsPerPage(+event.target.value);
         setCurrentPage(0);
     };

    //set edited rows
    const setRowHandler = (value, obj, updatedRow) => {
        const index = rows.indexOf(updatedRow);
        if (updatedRow.id != "") {
            const row = rows[index];
            row[obj] = value;
            rows[index] = row;
            setRows(rows);
        } else {
            const row = rows[index];
            row[obj] = value;
            setRows(rows);
        }
        if (value.length > 0) {
            if (obj === "code") {
                setError({ ...error, equipmentReportCodeError: "" });
            } else if (obj === "name") {
                setError({ ...error, equipmentReportNameError: "" });
            } else if (obj === "plantCode") {
                setError({ ...error, plantError: "" });
            }
            
            
        } else {
            if (obj === "code") {
                setError({ ...error, equipmentReportCodeError: t("GroupCodeValidation") });
            } else if (obj === "name") {
                setError({ ...error, equipmentReportNameError: t("GroupNameValidation") });
            } else if (obj === "plantCode") {
                setError({ ...error, plantError: t("PlantCodeValidation") });
            }
        }

    };

    const updateAddHandler = (row) => {
        // update
        if (row.id !== "") {
            let updatePlantID = "";
            //set default values for equipment code and name
            row.code = row.code === undefined ? row.group.code : row.code;
            row.name = row.name === undefined ? row.group.name : row.name;
            updatePlantID = newPlantID(row.plantCode)[0];
            let data = {
                id: row.id,
                code: row.code,
                name: row.name,
                plantId: updatePlantID,
                status: 1,
            };
            dispatch(updateEquipmentReport(data));
        }
        // add
        else {
            const data =  {
                code: row.code,
                name: row.name,
                plantId: addPlantID,
                breakdownRootCauseLocalizationName: row.breakdownRootCauseLocalizationName,
            };
          
            dispatch(addEquipmentReport(data));
        }
    };

    const disableEditHandler = () => {
        filterData(filterText);
        setEditable(false);
        //enable edit button
        setDisableButton(false);

        setError({
            equipmentReportCodeError: t("GroupCodeValidation"),
            equipmentReportNameError: t("GroupNameValidation"),
            plantError: t("PlantCodeValidation")
        });
    };

    //filter table
    const [filterText, setFilterText] = useState("");
    const [disableButton, setDisableButton] = useState(false);

    // Filter table
    const filterData = (value) => {
        const newFilteredText = value.toLowerCase();
        setFilterText(newFilteredText);
        let filteredItems = cloneObject(initialRows).filter((item) => item.code.toLowerCase().includes(newFilteredText) || item.name.toLowerCase().includes(newFilteredText) || item.plantCode.toLowerCase().includes(newFilteredText));
        setRows(filteredItems);
        setDisableButton(false);
    };

    useEffect(() => {
        filterData(filterText);
    }, [initialRows]);

    //modal
    const [isModalOpen, setModalOpen] = useState(false);
    const [deletedRow, setDeletedRow] = useState([]);
    const deleteButtonHandler = (row) => {
        setDeletedRow(row);
        toggleModal();
    };

    const toggleModal = () => {
        setModalOpen((prevState) => !prevState);
    };

    const enableEditHandler = (row) => {
        if (disableButton || editable) {
            filterData(filterText);
        }
        setDisableButton(true);
        setEditableRow(row.id);
        setEditable(true);

        setError({
            equipmentReportCodeError: "",
            equipmentReportNameError: "",
            plantError: ""
        });
    };

    //add blank row for new plant addition
    const addBlankRowHandler = () => {
        setAddedPlantName("");
        setCurrentPage(0);
        setDisableButton(true);
        const addedBlankRow = [
            {
                id: "",
                plantCode: "",
                plantName: "",
                code: "",
                name: "", // Correction By Finosys Team
                equipmentRelationLst: [
                    {
                        equipmentCode: "",
                        equipmentName: "",
                    },
                ],
            },
        ];

        rows = addedBlankRow.concat(rows);
        setEditableRow(addedBlankRow[0].id);
        setEditable(true);
        setRows(rows);
    };

    const deleteHandler = (row) => {
        toggleModal();
        const deletePlantID = newPlantID(row.plantCode)[0];
        const data = {
            id: row.id,
            code: row.code,
            name: row.name,
            plantId: deletePlantID,
        };
        dispatch(deleteEquipmentReport(data));
    };

    const [error, setError] = useState({
        equipmentReportCodeError: t("GroupCodeValidation"),
        equipmentReportNameError: t("GroupNameValidation"),
        plantError: t("PlantCodeValidation")
    });

    useEffect(() => {
        if (error.equipmentReportCodeError === "" && error.equipmentReportNameError === "" && error.plantError === "") {
            setIsAddDisable(false);
        } else {
            setIsAddDisable(true);
        }
    }, [error]);

    //expand row
    const [openRow, setOpenRow] = useState(false);
    const [expandID, setExpandId] = useState("");
    const expandRow = (rowId) => {
        if (openRow && expandID !== rowId) {
            setExpandId(rowId);
        } else {
            setOpenRow(!openRow);
            setExpandId(rowId);
        }
    };

    //set plantID
    let [addPlantID, setAddedPlantID] = useState(0);
    let [addPlantName, setAddedPlantName] = useState("");

   const newPlantID = (plantCode) => {
        if (plantCode) {
            const filteredPlant = plantList.filter((item) =>
                item.code.includes(plantCode)
            );
            setAddedPlantID(filteredPlant[0].id);
            setAddedPlantName(filteredPlant[0].name);
            return [filteredPlant[0].id, filteredPlant[0].name];
        } else {
            setAddedPlantID(0);
            setAddedPlantName("");
        }
    };

    return (
        <StyledTableDiv>
        <h1>
            {t("EquipmentReportGroup")} {t("List")}{" "}
        </h1>
        <AddButton
            onClick={() => addBlankRowHandler()}
            disabled={disableButton}
        />
        {pageLoaded === true ? (
            <Grid
                container
                spacing={4}
                alignItems="center"
                justifyContent="center"
                sx={{ marginBottom: 4 }}
            >
                <Grid item xs={12} sm={12} md={4}>
                    <SearchBar value={filterText} onChange={(newValue) => setFilterText(newValue)} onRequestSearch={(value) => filterData(value)} />
                </Grid>
            </Grid>
        ) : null}
        <Box m={2} />
        {rows.length > 0 ? (
            <Grow
                in={true}
                style={{ transformOrigin: "0 0 0" }}
                {...{ timeout: 1000 }}
            >
                <TableContainer component={Paper}>
                    <Table id="erg_Table" aria-label="simple table">
                            <TableHead id="erg_TableHead">
                                <TableRow id="erg_TableRow">
                                    {renderTableCell([
                                        { id: "", label: t("") },
                                        { id: "id", label: t("ID") },
                                        { id: "NumberOfEquipment", label: t("NumberOfEquipment") },
                                        { id: "code", label: t("GroupCode") },
                                        { id: "name", label: t("GroupName") },
                                        { id: "plantCode", label: t("PlantCode") },
                                        { id: "plantName", label: t("PlantName") },
                                        { id: "Actions", label: t("Actions") },
                                    ])}
                                </TableRow>
                            </TableHead>
                            <TableBody id="erg_TableBody">
                                {rows.slice(
                                    currentPage * rowsPerPage,
                                    currentPage * rowsPerPage + rowsPerPage
                                    ).map((row, index) => (
                                    <React.Fragment key={row.id}>
                                   <TableRow id={`gt_TableRow_${index}`} key={row.id}>
                                            <TableCell id={`erg_TableCell_${index}`}>
                                                <IconButton id={`erg_TableCell_IconButton_${index}`} aria-label="expand row" size="small" onClick={() => expandRow(row.id)}>
                                                    {openRow && expandID === row.id ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                                                </IconButton>
                                            </TableCell>
                                            <TableCell id={`erg_TableCell_1_${index}`} align="center">
                                                {row.id}
                                            </TableCell>
                                            <TableCell id={`erg_TableCell_2_${index}`} align="center">
                                                {row.equipmentRelationLst?.length}
                                            </TableCell>
                                            <TableCell id={`erg_TableCell_3_${index}`} align="center">
                                                {editable && editableRow === row.id ? (
                                                    <TextField
                                                        id={`erg_TableCell_3_TextField_${index}`}
                                                        onInput={(e) => setRowHandler(e.target.value, "code", row)}
                                                        defaultValue={row.code}
                                                        variant="outlined"
                                                        helperText={error.equipmentReportCodeError} 
                                                        FormHelperTextProps ={{id: "erg_val1"}}
                                                    />
                                                ) : (
                                                    row.code
                                                )}
                                            </TableCell>
                                            <TableCell id={`erg_TableCell_4_${index}`} align="center">
                                                {editable && editableRow === row.id ? (
                                                    <TextField
                                                        id={`erg_TableCell_4_TextField_${index}`}
                                                        onInput={(e) => setRowHandler(e.target.value, "name", row)}
                                                        defaultValue={row.name}
                                                        variant="outlined"
                                                        helperText={error.equipmentReportNameError} 
                                                        FormHelperTextProps ={{id: "erg_val2"}}
                                                    />
                                                ) : (
                                                    row.name
                                                )}
                                            </TableCell>

                                            <TableCell id={`erg_TableCell_5_${index}`} align="center">
                                                {editable && editableRow === row.id && editableRow === "" ? (
                                                    <Autocomplete
                                                        id={`erg_TableCell_5_Autocomplete_${index}`}
                                                        defaultValue={row.plantCode}
                                                        onChange={(event, newValue) => {
                                                            newValue = newValue ? newValue : "";
                                                            newPlantID(newValue);
                                                            setRowHandler(newValue, "plantCode", row)
                                                        }}
                                                        options={plantList.map((option) => option.code)}
                                                        renderInput={(params) => <TextField id={`erg_TableCell_5_TextField_${index}`} {...params} margin="normal" variant="outlined" helperText={error.plantError}  FormHelperTextProps ={{id: "erg_val3"}} />}
                                                    />
                                                ) : (
                                                    row.plantCode
                                                )}
                                            </TableCell>
                                            <TableCell align="center"  id={`erg_TableCell_6_${index}`}> {editable && editableRow === row.id && editableRow === "" ? addPlantName : row.plantName}</TableCell>
                                            <TableButtons
                                                editable={editable}
                                                editableRow={editableRow}
                                                row={row}
                                                updateAddHandler={() => updateAddHandler(row)}
                                                disableEditHandler={() => disableEditHandler()}
                                                enableEditHandler={() => enableEditHandler(row)}
                                                deleteButtonHandler={() => deleteButtonHandler(row)}
                                                detail={false}
                                                addDisabled={isAddDisable}
                                            />
                                        </TableRow>
                                        <TableRow id={`gt_TableCell_TableRow_${index}`}>
                                                {expandID === row.id ? (
                                                    <TableCell id={`gt_TableCell_TableRow_TC${index}`} style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={8}>
                                                        <Collapse id={`gt_TableCell_TableRow_Collapse_${index}`} in={openRow} timeout="auto" unmountOnExit>
                                                            <Box id={`gt_TableCell_TableRow_Box_${index}`} margin={1}>
                                                                <Typography id={`gt_TableCell_TableRow_Typo_${index}`} variant="h6" gutterBottom component="div">
                                                                    {t("Equipments")}
                                                                </Typography>
                                                                <Table id={`gt_TableCell_TableRow_Table_${index}`} size="small">
                                                                    <TableHead id={`gt_TableCell_TableRow_TH_${index}`}>
                                                                        <TableRow id={`gt_TableCell_TableRow_TR_${index}`}>
                                                                            <TableCell id={`gt_TableCell_TableRow_TC1_${index}`} align="center">
                                                                                {t("EquipmentCode")}
                                                                            </TableCell>
                                                                            <TableCell id={`gt_TableCell_TableRow_TC2_${index}`} align="center">
                                                                                {t("EquipmentName")}
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    </TableHead>
                                                                    <TableBody id={`gt_TableCell_TableRow_TB_${index}`}>
                                                                        {row.equipmentRelationLst.map((detailRow) => (
                                                                            <TableRow id={`gt_TableCell_TableRow_TR2_${index}`} key={detailRow.id}>
                                                                                <TableCell id={`gt_TableCell_TableRow_TC3_${index}`} align="center">
                                                                                    {detailRow.equipmentCode}
                                                                                </TableCell>
                                                                                <TableCell id={`gt_TableCell_TableRow_TC4_${index}`} align="center">
                                                                                    {detailRow.equipmentName}
                                                                                </TableCell>
                                                                            </TableRow>
                                                                        ))}
                                                                    </TableBody>
                                                                </Table>
                                                            </Box>
                                                        </Collapse>
                                                    </TableCell>
                                                ) : null}
                                            </TableRow>
                                    </React.Fragment>
                                ))}
                            </TableBody>
                        </Table>

                    <TablePagination
                        rowsPerPageOptions={[20, 50, 100]}
                        component="div"
                        count={rows.length}
                        rowsPerPage={rowsPerPage}
                        page={currentPage}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </TableContainer>
            </Grow>
        ) : null}
        <Modal
            title={t("Delete")}
            content={t("WillYouDoTransaction")}
            approved={() => deleteHandler(deletedRow)}
            isModalOpen={isModalOpen}
            toggle={toggleModal}
        />
        <LoadingBackdrop />
    </StyledTableDiv>
        
    );
}
